import { Workspace, AdProject, AdPage, AdHeaderElement, AdImageElement } from './adCreatorTypes'; // Adjusted import path

const samplePage1Elements: (AdHeaderElement | AdImageElement)[] = [
  {
    id: 'p1h1',
    type: 'header',
    name: 'Page 1 Header',
    x: 10,
    y: 10,
    width: 280,
    height: 30,
    text: 'Welcome to Summer Savings!',
    level: 2,
    textAlign: 'center',
    fontSize: '20px',
  },
  {
    id: 'p1img1',
    type: 'image',
    name: 'Beach Offer',
    x: 10,
    y: 50,
    width: 280,
    height: 150,
    src: '/assets/placeholder-hero.png', // Assuming assets are in public/assets
    altText: 'Summer beach scene with offer details',
    objectFit: 'cover',
  },
];

const samplePage2Elements: (AdHeaderElement | AdImageElement)[] = [
  {
    id: 'p2h1',
    type: 'header',
    name: 'Page 2 Header',
    x: 10,
    y: 10,
    width: 280,
    height: 30,
    text: 'Explore Our Top Deals',
    level: 2,
    textAlign: 'center',
    fontSize: '20px',
  },
  {
    id: 'p2img1',
    type: 'image',
    name: 'Product Showcase',
    x: 10,
    y: 50,
    width: 280,
    height: 150,
    src: '/assets/placeholder-product.png',
    altText: 'Showcase of top products on sale',
    objectFit: 'contain',
  },
];

const samplePage3Elements: (AdHeaderElement | AdImageElement)[] = [
  {
    id: 'p3h1',
    type: 'header',
    name: 'Page 3 Header',
    x: 10,
    y: 10,
    width: 280,
    height: 30,
    text: 'Limited Time Offer!',
    level: 2,
    textAlign: 'center',
    fontSize: '20px',
  },
  {
    id: 'p3img1',
    type: 'image',
    name: 'Call to Action',
    x: 10,
    y: 50,
    width: 280,
    height: 150,
    src: '/assets/placeholder-cta.png',
    altText: 'Urgent call to action graphic',
    objectFit: 'cover',
  },
];

const sampleAdPages: AdPage[] = [
  { id: 'page1', name: 'Intro Offer', elements: samplePage1Elements, backgroundColor: '#f0f8ff' },
  {
    id: 'page2',
    name: 'Product Details',
    elements: samplePage2Elements,
    backgroundColor: '#e6e6fa',
  },
  { id: 'page3', name: 'Final Call', elements: samplePage3Elements, backgroundColor: '#fff0f5' },
];

const sampleAdProject: AdProject = {
  id: 'ad123',
  name: 'Summer Splash Campaign',
  description: 'A vibrant campaign for summer promotions.',
  heroImage: '/assets/placeholder-hero.png',
  pages: sampleAdPages,
  workspaceId: 'ws1',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  settings: { defaultWidth: 300, defaultHeight: 250 },
};

export const mockWorkspaces: Workspace[] = [
  {
    id: 'ws1',
    name: 'Primary Workspace',
    ownerId: 'user1',
    adProjects: [
      sampleAdProject,
      {
        id: 'ad456',
        name: 'Winter Warmers',
        description: 'Cozy winter deals.',
        heroImage: '/assets/placeholder-winter.png',
        pages: [sampleAdPages[0]], // simplified for brevity
        workspaceId: 'ws1',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'ws2',
    name: 'Client X Campaigns',
    ownerId: 'user1',
    adProjects: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
